import type {
  PageTopbarSettings,
  TopbarDefinition,
  TopbarSettings,
} from "../cms/topbar";

export function selectTopbar(
  definitions: readonly TopbarDefinition[] | undefined,
  website: TopbarSettings | undefined,
  page: PageTopbarSettings | undefined,
): TopbarDefinition | undefined {
  if (website?.enabled === false) return undefined;
  if (page?.id === null) return undefined;
  const available = Array.isArray(definitions) ? definitions : [];
  const find = (id: unknown) =>
    typeof id === "string" && id !== ""
      ? available.find(
          (item) => item && item.id === id && Array.isArray(item.sections),
        )
      : undefined;
  return find(page?.id) ?? find(website?.activeId);
}

/** Height is a minimum in pixels, with the normal mobile|desktop syntax. */
export function topbarHeight(value: unknown): {
  mobile: string;
  desktop: string;
} {
  const parts =
    typeof value === "string" || typeof value === "number"
      ? String(value)
          .split("|")
          .map((part) => part.trim())
      : [];
  const safe = (part: string | undefined) => {
    const match = /^(\d+(?:\.\d+)?)\s*(?:px)?$/.exec(part ?? "");
    const height = match ? Number(match[1]) : 40;
    return `${Number.isFinite(height) && height >= 0 ? height : 40}px`;
  };
  return { mobile: safe(parts[0]), desktop: safe(parts[1] ?? parts[0]) };
}
